import { createNamespacedHelpers } from 'vuex';
import orderBy from 'lodash/orderBy';

const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'ConciergeTableContent',
  computed: {
    ...mapConciergeState({
      conciergeList: state => state.conciergeList
    }),
    orderedConciergeList: function() {
      return orderBy(this.conciergeList, ['totalRewards'], ['desc']);
    }
  }
};
